<template>
<div>
  <div class="row justify-content-center">
                      <div class=" col-sm-12 grid-margin stretch-card">

                        <div class="card">
                          <div class="card-tile text-center p-2">
                            <ul class="nav nav-pills nav-fill">
  <li class="nav-item">
    <a class="nav-link active" aria-current="page" href="#">Safaricom Zambaza Lines</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" href="/numbers/airtel">Airtel Receiver Lines</a>
  </li>
</ul>

                            <div class="mb-3 row justify-content-center mt-5">
                              <div class="col-sm-7 float-right">
                              <input type="text" v-model="message.filterval"  v-on:keyup="filter()" class="form-control" placeholder="Type to start filtering">

                              </div>
                               <div class="col-sm-2 float-right">
                                <a class="btn btn-success" v-on:click="showAddModal()">Add Numbers</a>
                               </div>
                               <div class="col-sm-3 float-right">
                                <a href="#" class="tex-success" v-on:click="showAddModal2()"><i class="fa fa-bell faa-ring animated fa-4x text-success"></i></a>
                               </div>
                            </div>
                            </div>
                          <div class="card-body text-center">

                            <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>

                    <tr class="text-center">
                      <th class="text-uppercase  text-xxs font-weight-bolder">#</th>
                      <th class="text-uppercase  text-xxs font-weight-bolder  ">Number</th>
                      <th class="text-uppercase  text-xxs font-weight-bolder  ">Limit</th>
                      <th class="text-uppercase  text-xxs font-weight-bolder  ">Credit Balance</th>
                      <th class="text-uppercase  text-xxs font-weight-bolder  ">Locked Status</th>
                      <th class="text-uppercase  text-xxs font-weight-bolder  ">Locked Number</th>
                      <th class=" text-uppercase  text-xxs font-weight-bolder ">Created At</th>
                      <th class=" text-uppercase  text-xxs font-weight-bolder ">Updated At</th>
                      <th class=" text-uppercase  text-xxs font-weight-bolder ">Status</th>
                      <th class=" text-uppercase  text-xxs font-weight-bolder ">Action</th>

                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data,index) in numbers" :key="data.id" class="text-center" v-bind:class = "(data.status)?'bg-default':'bg-secondary'">
                      <td>
                        {{index+1}}
                      </td>
                      <td>
                        {{data.number}} <a href="#" v-on:click="showModal(data.id,data.number,data.balance,data.status,data.actual_balance)" class=""><i class="mdi mdi-pencil text-success"></i></a>
                      </td>
                      <td>
                        {{formatPrice(data.balance)}}  <a href="#" v-on:click="showModal(data.id,data.number,data.balance,data.status,data.actual_balance)" class=""><i class="mdi mdi-pencil text-success"></i></a>
                      </td>
                      <td class="text-primary">
                        {{formatPrice(data.actual_balance)}}  <a href="#" v-on:click="showModal(data.id,data.number,data.balance,data.status,data.actual_balance)" class=""><i class="mdi mdi-pencil text-success"></i></a>
                      </td>
                      <td>
                        {{data.locked}}
                      </td>
                      <td>
                        {{data.msisdn}}
                      </td>
                      <td>
                        {{filerDate(data.created_at)}}
                      </td>
                      <td>
                        {{filerDate(data.updated_at)}}
                      </td>
                      <td v-if="data.status">
                        <label class="switch">
  <input type="checkbox" checked v-on:click="updateNumberStatus(data.id,data.number,data.balance,false,data.actual_balance)">
  <span class="slider round"></span>
</label>
                      </td>
                      <td v-else>
                        <label class="switch">
  <input type="checkbox" v-on:click="updateNumberStatus(data.id,data.number,data.balance,true,data.actual_balance)">
  <span class="slider round"></span>
</label>
                      </td>
                      <td>
                         <a href="#" v-on:click="removeConfirmNumber(data.id,data.number)" class=""><i class="fa fa-remove fa-2x text-danger"></i></a>
                      </td>

                    </tr>
                  </tbody>
                </table>
              </div>

                          </div>
                        </div>




                        </div>
                        </div>

  <div class="modal fade" id="add" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">

      <div class="modal-body">
         <h6 class="text-center">Add a Number</h6>
         <div class="form-group">
                    <label class="form-label">Number</label>
                    <input type="text" v-model="message.number" class="form-control" required>
                  </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-success" v-on:click="addNumber()">Save Number</button>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="add3" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">

      <div class="modal-body">
         <h6 class="text-center">Send Reminders</h6>
         <div class="conatiner">
                    <h5 class="text-center">Please click the bell Button labled  <i class="fa fa-bell faa-ring animated fa-4x text-success"></i> on the Top Right container to send Sms alerts when the airtime float is available.</h5>
                  </div>
      </div>
      <div class="modal-footer">
        <!-- <button type="button" class="btn btn-success" v-on:click="addNumber()">Save Number</button> -->
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="add2" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">

      <div class="modal-body">
         <h6 class="text-center">Send SMs alerts to Buyers who are subscribed.</h6>
         <div class="form-group">
                    <label class="form-label">Message (editable)</label>
                    <textarea class="form-control" v-model="message.message" rows="8"></textarea>
                  </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-success" v-on:click="sendAlert()">Send Alert</button>
      </div>
    </div>
  </div>
</div>
  <div class="modal fade" id="edit" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">

      <div class="modal-body">
         <h6 class="text-center">Update Number</h6>
         <div class="form-group">
                    <label class="form-label">Number</label>
                    <input type="text" v-model="message.number" class="form-control" required>
                  </div>
                  <div class="form-group">
                    <label class="form-label">Limit</label>
                    <input type="text" v-model="message.balance" class="form-control" required>
                  </div>
                  <div class="form-group">
                    <label class="form-label">Credit Balance</label>
                    <input type="text" v-model="message.actual_balance" class="form-control" required>
                  </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-success" v-on:click="updateNumber()">Save changes</button>
      </div>
    </div>
  </div>
</div>
</div>
</template>
<script>
    import moment from 'moment'
    export default {
        name: 'App',
        components: {

        },
        data(){
            return {
            numbers:[],
            numbers2:[],
            message:{id:'',number:'',balance:'0',status:false,actual_balance:'0',message:'Dear customer,SwapKredo cheap airtime float is now available.Please visit our site to purchase.'}

            }
        },
        created(){
              this.getNumbers();

        },
        methods: {
            showReminderModal(){
                $('#add3').modal('show');
            },
          showAddModal(){
              $('#add').modal('show');
          },
          showAddModal2(){
            $('#add2').modal('show');
          },
          showModal(id,number,balance,status,actual_balance){
            this.message.number=number;
            this.message.id=id;
            this.message.balance=balance;
            this.message.status=status;
            this.message.actual_balance=actual_balance;
             $('#edit').modal('show');
          },
          addNumber(){
            $('#add').modal('hide');
             this.$loading(true)
               let uri =`/api/auth/addNumber`;
                this.axios.post(uri,this.message, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                    this.$loading(false)
                   if(response.data.status){
                   this.$toast.open({message: response.data.message, type: 'success', position: 'top'});
                   this.getNumbers();
                   }else{
                   this.$toast.open({message: response.data.message, type: 'error', position: 'top'});
                   }
                }).catch(error => {
                   this.$loading(false)
                    if (error.response.status === 401) {
                    this.$router.push({name: 'index'});
                    this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});

                }else{
                    this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                }

                });
          },
          sendAlert(){
            $('#add2').modal('hide');
             this.$loading(true)
               let uri =`/api/auth/sendAlert`;
                this.axios.post(uri,this.message, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                    this.$loading(false)
                   if(response.data.status){
                   this.$toast.open({message: response.data.message, type: 'success', position: 'top'});
                   this.getNumbers();
                   }else{
                   this.$toast.open({message: response.data.message, type: 'error', position: 'top'});
                   }
                }).catch(error => {
                   this.$loading(false)
                    if (error.response.status === 401) {
                    this.$router.push({name: 'index'});
                    this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});

                }else{
                    this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                }

                });
          },
          removeConfirmNumber(id,number){
            this.$swal({
             title: 'Are you sure youi want to delete this number->'+number,
              text: "You won't be able to revert this!",
              icon: 'warning',
             showCancelButton: true,
               confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
               confirmButtonText: 'Yes, delete it!'
              }).then((result) => {
               if (result.isConfirmed) {
                   this.removeNumber(id);
                 }
            })

          },
          removeNumber(id){
             this.$loading(true)
               let uri =`/api/auth/removeNumber/${id}`;
                this.axios.get(uri, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                    this.$loading(false)
                   if(response.data.status){
                   this.$toast.open({message: response.data.message, type: 'success', position: 'top'});
                   this.getNumbers();
                   }else{
                   this.$toast.open({message: response.data.message, type: 'error', position: 'top'});
                   }
                }).catch(error => {
                   this.$loading(false)
                    if (error.response.status === 401) {
                    this.$router.push({name: 'index'});
                    this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});

                }else{
                    this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                }

                });
          },
          updateNumberStatus(id,number,balance,status,actual_balance){
            this.message.id=id;
            this.message.status=status;
            this.message.number=number;
            this.message.balance=balance;
            this.message.actual_balance=actual_balance;
             this.$loading(true)
               let uri =`/api/auth/updateNumber`;
                this.axios.post(uri,this.message, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                    this.$loading(false)
                   if(response.data.status){
                   this.$toast.open({message: response.data.message, type: 'success', position: 'top'});
                   this.getNumbers();
                   }else{
                   this.$toast.open({message: response.data.message, type: 'error', position: 'top'});
                   }
                }).catch(error => {
                   this.$loading(false)
                    if (error.response.status === 401) {
                    this.$router.push({name: 'index'});
                    this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});

                }else{
                    this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                }

                });
          },
          updateNumber(){
            $('#edit').modal('hide');
             this.$loading(true)
               let uri =`/api/auth/updateNumber`;
                this.axios.post(uri,this.message, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                    this.$loading(false)
                   if(response.data.status){
                   this.$toast.open({message: response.data.message, type: 'success', position: 'top'});
                   this.getNumbers();
                   }else{
                   this.$toast.open({message: response.data.message, type: 'error', position: 'top'});
                   }
                }).catch(error => {
                   this.$loading(false)
                    if (error.response.status === 401) {
                    this.$router.push({name: 'index'});
                    this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});

                }else{
                    this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                }

                });
          },
            getNumbers(){
                let uri =`/api/auth/getNumbers`;
                this.axios.get(uri, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                    this.numbers2=response.data;
                   this.numbers=response.data;
                }).catch(error => {

                   if (error.response.status === 401) {
                    this.$router.push({name: 'index'});
                    this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});

                }else{
                    this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                }

                });
            },

            filter(){
            let filterval=this.message.filterval;
            if(filterval==='' || filterval===null){
                this.numbers=this.numbers2;
            }else{
                let ads =  this.numbers2.filter(function(product) {
                    return product.number.toLowerCase().includes(filterval.toLowerCase())
                });
                this.numbers=ads;
            }
        },
            formatPrice(value) {
                let val = (value/1).toFixed(2).replace('.', '.');
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            filerDate(date){
                return moment(String(date)).format('MM/DD/YYYY HH:mm')
            }

        },
    }

</script>
